export const enableMockServiceWorker = async () => {
  if (import.meta.env.VITE_APP_ENV !== 'test') {
    return;
  }

  const { worker } = await import('./browser');

  worker.start({
    onUnhandledRequest(req, print) {
      if (req.url.includes(import.meta.env.VITE_CLAIMSCORE_API_URL)) {
        print.warning();
      }
    },
  });
};
